import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ManufacturerFilter from './ManufacturerFilter';
import ModelFilter from './ModelFilter';
import { FilterContext } from '../internal';

const propTypes = {
  isModelsLoading: PropTypes.bool.isRequired
};

const MakeManufacturerFilter = ({ isModelsLoading }) => {
  const {
    filterMetaData,
    updateSelectedManufacturers,
    updateSelectedModels
  } = useContext(FilterContext);

  const displayModelFilter = () => {
    return isModelsLoading || Object.keys(filterMetaData?.models).length > 0;
  };

  return (
    <>
      <ManufacturerFilter
        filterMetaData={filterMetaData}
        updateSelectedManufacturers={updateSelectedManufacturers}
      />
      {displayModelFilter() && (
        <ModelFilter
          filterMetaData={filterMetaData}
          updateSelectedModels={updateSelectedModels}
        />
      )}
    </>
  );
};

MakeManufacturerFilter.propTypes = propTypes;

export default MakeManufacturerFilter;
